var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasVariants
    ? _c(
        "div",
        { class: [_vm.dropdownCss], on: { click: _vm.toggleDropdown } },
        [
          _c(
            "ul",
            { attrs: { "data-test": "product-variant-dropdown" } },
            [
              _c("li", { staticClass: "selected" }, [
                _vm._v(_vm._s(_vm.dropdownTitle)),
              ]),
              _vm._v(" "),
              _vm._l(_vm.variants, function (variant) {
                return _c(
                  "li",
                  {
                    key: variant.id,
                    staticClass: "variant-dropdown",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.setSelected(variant)
                      },
                    },
                  },
                  [
                    _vm._v("\n      " + _vm._s(variant.title) + "\n      "),
                    !_vm.isAvailable(variant)
                      ? _c("span", [_vm._v("(Out of stock)")])
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }